export default function EmptyConnectionsState() {
  return (
    <div className="mb-10 text-center">
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-slate-100 dark:bg-slate-800 mb-4">
        <span className="material-symbols-outlined text-3xl text-slate-400">cloud_off</span>
      </div>
      <h3 className="text-lg font-medium text-slate-900 dark:text-white">
        Aún no tienes adquirentes conectados
      </h3>
      <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
        Conecta tu primera cuenta para comenzar a sincronizar tus ventas automáticamente.
      </p>
    </div>
  );
}
